'use client';

import { useCallback, useContext } from 'react';
import Composer from '@/common/Composer';
import ComposerUiMfe from '@/common/ComposerUi/ComposerUiMfe';
import StaticContext from '~/context/common/StaticContext';
import { useModalContext } from '~/context/vdp/ModalContext/ModalContext';

export default function VdpComposerUi() {
  const { showComposerUi } = useContext(StaticContext);
  const { isComposerUiModalOpen, setComposerUiModalOpen } = useModalContext();

  const handleClose = useCallback(
    () => setComposerUiModalOpen(false),
    [setComposerUiModalOpen]
  );
  const handleOpen = useCallback(
    () => setComposerUiModalOpen(true),
    [setComposerUiModalOpen]
  );

  if (!showComposerUi) return null;

  return (
    <>
      <ComposerUiMfe
        isOpen={isComposerUiModalOpen}
        onRequestClose={handleClose}
      />
      <div className="fixed inset-x-0 bottom-0 z-40 max-md:-translate-y-[100px]">
        <Composer inputPlaceholder="" onOpenAction={handleOpen} />
      </div>
    </>
  );
}
